import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import React, { Component } from 'react';
import styled, { css } from 'styled-components';

import { EGP_IMG } from '~/src/constants';

const TooltipContainer = styled.div`
    background-color: ${COLORS.white};
    box-sizing: border-box;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
    color: ${COLORS.TextPrimary};
    display: block;
    padding: 32px 24px;
    position: fixed;
    width: 528px;
    z-index: 10;

    ${({ coordinates = { x: 0, y: 0 }, isReverse = false }) => css`
        left: ${coordinates.x}px;
        top: ${coordinates.y}px;
        transform: ${isReverse ? 'translate(-50%, 20px)' : 'translate(-50%, -100%) translateY(-20px)'};
    `}

    @media only screen and (max-width: 767px) {
        box-shadow: none;
        overflow-y: auto;
        padding: 0;
        bottom: 0;
        left: 0;
        top: 50px;
        transform: none;
        width: 100%;
        z-index: 100;
    }

    &::after {
        background-color: ${COLORS.white};
        content: "";
        position: absolute;
        left: 50%;
        height: 20px;
        width: 20px;
        z-index: 10;

        ${({ isReverse = false }) => {
            if (isReverse) {
                return css`
                    border-top: 1px solid rgba(195, 195, 195, 0.25);
                    border-left: 1px solid rgba(195, 195, 195, 0.25);
                    top: 0;
                    transform: translate(-50%, -50%) rotate(45deg);
                `;
            } else {
                return css`
                    bottom: 0;
                    box-shadow: 6px 6px 10px rgba(0, 0, 0, 0.12);
                    transform: translate(-50%, 50%) rotate(45deg);
                `;
            }
        }}

        @media only screen and (max-width: 767px) {
            content: none;
        }
    }
`;

const TooltipCloseButton = styled.div`
    cursor: pointer;
    position: absolute;
    right: 20px;
    top: 20px;
    transform:rotate(-45deg);
    height: 23px;
    width: 23px;
    z-index: 10;

    @media only screen and (max-width: 767px) {
        position: fixed;
        top: 70px;
    }

    &::after,
    &::before {
        background-color: ${COLORS.GRAY_DARK};
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 1px;
        width: 100%;
        z-index: 10;
    }

    &::after {
        transform: translate(-50%, -50%) rotate(-90deg);
    }
`;

const TooltipImage = styled.img`
    max-height: 112px;
    max-width: 100%;

    @media only screen and (max-width: 767px) {
        max-height: none;
        width: 100%;
    }
`;

const TooltipTitle = styled.div`
    ${FONTS.L};
    margin-top: 30px;
    width: 100%;

    @media only screen and (max-width: 767px) {
        margin-top: 30px;
        padding: 0 14px;
    }
`;

const TooltipDescription = styled.div`
    ${FONTS.S};
    margin-top: 9px;
    width: 100%;

    @media only screen and (max-width: 767px) {
        margin-top: 15px;
        padding: 0 14px;
    }
`;

export default class ScheduleTooltip extends Component {
    static defaultProps = {
        content: {},
        coordinates: { X: 0, y: 0 },
    };

    state = {
        coordinates: this.props.coordinates,
        isReverse: false,
    }

    constructor(props) {
        super(props);
        this.tooltipNode = React.createRef();
        this.resizeTimer = null;
    }

    componentDidMount() {
        this.isMobile = window.matchMedia('(max-width: 767px)').matches;
        if (this.props.isShow) {
 this.tooltipOpen();
}

        document.addEventListener('click', this.onDocumentClick);
        window.addEventListener('resize', this.onWindowResize);

        if (this.isMobile === false) {
            window.addEventListener('scroll', this.tooltipClose);
        }
    }

    componentDidUpdate({ coordinates }) {
        if (JSON.stringify(coordinates) !== JSON.stringify(this.props.coordinates)) {
            this.setState({ coordinates: this.props.coordinates }, this.tooltipOpen);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.onDocumentClick);
        window.removeEventListener('resize', this.onWindowResize);
        window.removeEventListener('scroll', this.tooltipClose);
    }

    correctCoordinates() {
        const containerRect = this.props.container.getBoundingClientRect();
        const tooltipRect = this.tooltipNode.current.getBoundingClientRect();

        const newCoordinates = { ...this.props.coordinates };
        let isReverse = false;

        if (tooltipRect.left < containerRect.left) {
            newCoordinates.x += containerRect.left - tooltipRect.left;
        }

        if (tooltipRect.right > containerRect.right) {
            newCoordinates.x -= tooltipRect.right - containerRect.right;
        }

        if (tooltipRect.top < 0) {
            isReverse = true;
        }

        this.setState({
            coordinates: newCoordinates,
            isReverse,
        });
    }

    tooltipOpen = () => {
        if (this.isMobile) {
            document.body.style.overflow = 'hidden';
        }

        this.setState({ isReverse: false }, this.correctCoordinates);
    }

    tooltipClose = () => {
        document.body.style.overflow = '';
        this.props.tooltipClose();
    }

    onDocumentClick = (event) => {
        if (this.tooltipNode.current === null) {
 return;
}

        if (!this.tooltipNode.current.contains(event.target)) {
            this.tooltipClose();
        }
    }

    onWindowResize = () => {
        const isMobile = window.matchMedia('(max-width: 767px)').matches;

        if (isMobile !== this.isMobile) {
            this.isMobile = isMobile;

            if (isMobile === false) {
                window.removeEventListener('scroll', this.tooltipClose);
            } else {
                window.addEventListener('scroll', this.tooltipClose);
            }
        }

        if (this.props.isShow === false || isMobile === true) {
 return;
}

        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(this.tooltipClose, 200);
    }

    render() {
        let tooltip = null;

        if (this.props.isShow) {
            tooltip = (
                <TooltipContainer
                    coordinates={this.state.coordinates}
                    isReverse={this.state.isReverse}
                    ref={this.tooltipNode}
                >
                    <TooltipCloseButton onClick={this.tooltipClose} />
                    <TooltipImage
                        className='broadcast__tooltipImage'
                        alt={this.props.content.title}
                        src={`${EGP_IMG}${this.props.content.icon}`}
                    />
                    {this.props.content.title ? (<TooltipTitle>{this.props.content.title}</TooltipTitle>) : null}
                    {this.props.content.desc ? (<TooltipDescription>{this.props.content.desc}</TooltipDescription>) : null}
                </TooltipContainer>
            );
        }

        return tooltip;
    }
}
